import _ from '@/utils/lodash-optimized'
import PropTypes from 'prop-types'
import React from 'react'

import http from '../../../lib/http'
import { LinearProgress } from '../NarusMaterial/LinearProgress'

import { makeAutobindedInput } from './FormBuilder'
import { SelectField } from './Select'

class PractitionerTelecomSelectField extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      practitioners: null,
      loading: false,
      error: false
    }
  }

  UNSAFE_componentWillMount () {
    this.loadProviderNetwork()
  }

  loadProviderNetwork () {
    const { patientId } = this.props
    this.setState({ loading: true })
    return http
      .getRequest(`/patients/${patientId}/careNetwork`)
      .then(response => {
        this.setState({
          loading: false,
          practitioners: response,
          error: false
        })
      })
      .catch(e => {
        console.error(e)
        this.setState({
          loading: false,
          practitioners: null,
          error: true
        })
      })
  }

  render () {
    const { loading, error, practitioners } = this.state
    const { practitionerReference, system, label, externalReceivers, ...rest } =
      this.props

    if (loading) {
      return (
        <LinearProgress
          style={{
            marginTop: '20px',
            marginBottom: '16px'
          }}
        />
      )
    }
    if (error) {
      return <div>Error loading telecom information.</div>
    }

    const faxIsEnabled = a =>
        a.system === 'fax' && (a?.extension?.[0]?.valueCode ?? 'R') === 'R'

    const [ referenceType, referenceId ] = practitionerReference.split('/')

    let options = []

    if (referenceType === 'Practitioner') {
      const practitioner = practitioners.find(p => p.id === referenceId)

      options = (practitioner.telecom || [])
        .filter(a => {
          if (system === 'fax') {
            return a.system === system && a.value && faxIsEnabled(a)
          }
          return a.system === system && a.value
        })
        .map(t => ({
          code: t.value,
          value: t.value,
          label:
            system === 'email'
              ? t.value
              : `${t.value} - ${_.capitalize(t.use)}`
        }))
    } else if (referenceType === 'ExternalReceiver') {
      const externalReceiver = externalReceivers.find(
        p => p.id === parseInt(referenceId, 10)
      )

      options = [
        {
          code: externalReceiver[system],
          value: externalReceiver[system],
          label: externalReceiver[system]
        }
      ]
    }

    const selectStyle = {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'pre'
    }
    return (
      <SelectField
        style={selectStyle}
        label={label}
        options={options}
        {...rest}
      />
    )
  }
}

PractitionerTelecomSelectField.propTypes = {
  practitionerReference: PropTypes.string.isRequired,
  patientId: PropTypes.string.isRequired,
  system: PropTypes.oneOf([ 'email', 'fax' ]).isRequired,
  label: PropTypes.string.isRequired
}

export const PractitionerTelecomSelectInput = makeAutobindedInput(
  PractitionerTelecomSelectField
)
